var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chapter-template"},[_c('div',{ref:"preview",staticClass:"chapter-preview",style:({ width: _vm.previewWidth })})])
}
var staticRenderFns = []

export { render, staticRenderFns }